import React from 'react';
import { enqueueSnackbar } from '../../../common/components/Toast';
import I18n from '../../../common/i18n/I18n';
import { log } from '../../../common/utils/commonUtils';
import { ErrorType, getErrorMessage } from './CommonAuthUtils';

export function handleImportError(error: ErrorType, setSelectedSource: (source: any) => void) {
    log(error);
    const errorMessage = getErrorMessage(error);
    log(errorMessage);
    if (errorMessage) {
        enqueueSnackbar(<I18n token={errorMessage.token} />, { variant: errorMessage.variant });
    }
    setSelectedSource(null);
}
